export default __webpack_public_path__ + "static/media/delivery.713d2997.svg";